// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `a{
  text-decoration: none;
  color: white;
}

a:hover, a:active{
  color: lightgray;
}

.nav-caption{
  display: inline-block;
  padding-left: 6px;
}
`, "",{"version":3,"sources":["webpack://./src/app/sidenav-all-item/sidenav-all-item.component.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB","sourcesContent":["a{\n  text-decoration: none;\n  color: white;\n}\n\na:hover, a:active{\n  color: lightgray;\n}\n\n.nav-caption{\n  display: inline-block;\n  padding-left: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
